import React from 'react'
import {AiOutlineHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {IoSchool} from 'react-icons/io5'
import {BiBook} from 'react-icons/bi'
import {RiServiceLine} from 'react-icons/ri'
import {AiOutlineFundProjectionScreen} from 'react-icons/ai'
import {GiJetFighter} from 'react-icons/gi'
import {BiMessageSquareDetail} from 'react-icons/bi'
import { useState } from 'react'
import './nav.css'


const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  
  return (
    <nav>
      <a href="#home" onClick={()=>setActiveNav('#')} className={activeNav==='#' ? 'active':''}><AiOutlineHome /></a>
      <a href="#about" onClick={()=>setActiveNav('#about')} className={activeNav==='#about' ? 'active':''}><AiOutlineUser /></a>
      <a href="#courses" onClick={()=>setActiveNav('#courses')} className={activeNav==='#courses' ? 'active':''}><IoSchool /></a>
      <a href="#experience" onClick={()=>setActiveNav('#experience')} className={activeNav==='#experience' ? 'active':''}><BiBook /></a>
      <a href="#services" onClick={()=>setActiveNav('#services')} className={activeNav==='#services' ? 'active':''}><RiServiceLine /></a>
      <a href="#portfolio" onClick={()=>setActiveNav('#portfolio')} className={activeNav==='#portfolio' ? 'active':''}><AiOutlineFundProjectionScreen /></a>
      <a href="#competitions" onClick={()=>setActiveNav('#competitions')} className={activeNav==='#competitions' ? 'active':''}><GiJetFighter /></a>
      <a href="#contact" onClick={()=>setActiveNav('#contact')} className={activeNav==='#contact' ? 'active':''}><BiMessageSquareDetail /></a>
    </nav>
  )
}

export default Nav